export const pageKeys = [
  { value: "lobby", label: "mell.pageKeys.lobby" },
  { value: "information", label: "mell.pageKeys.information" },
  { value: "profile", label: "mell.pageKeys.profile" },
  { value: "wallet", label: "mell.pageKeys.wallet" },
  { value: "promotions", label: "mell.pageKeys.promotions" },
  { value: "bonuses", label: "mell.pageKeys.bonuses" },
  { value: "filters", label: "mell.pageKeys.filters" },
  { value: "liveCasino", label: "mell.pageKeys.liveCasino" },
]

export const pagesNames = {
  lobby: "mell.pagesNames.lobby",
  bonuses: "mell.pagesNames.bonuses",
  profile: "mell.pagesNames.profile",
  promotions: "mell.pagesNames.promotions",
  information: "mell.pagesNames.information",
  wallet: "mell.pagesNames.wallet",
  filters: "mell.pagesNames.filters",
  liveCasino: "mell.pagesNames.liveCasino",
}
